import type { ButtonHTMLAttributes } from "react";
import { ThemeAccent, ThemeButtonVariant, type ThemeSize } from "./theme.ts";

export const Button: React.FC<
	React.PropsWithChildren<
		ButtonHTMLAttributes<unknown> & {
			accent?: ThemeAccent;
			variant?: ThemeButtonVariant;
			size?: ThemeSize;
			href?: string;
		} & (
				| { loading?: never; loadingText?: never }
				| { loading: boolean; loadingText: string }
			)
	>
> = ({
	accent = ThemeAccent.Primary,
	variant = ThemeButtonVariant.Solid,
	children,
	size,
	href,
	loading,
	loadingText,
	value,
	...props
}) => {
	const classNames: string[] = [];
	classNames.push("button");
	if (loading) classNames.push("button-loading");
	accent && classNames.push(`button-${accent}`);
	variant && classNames.push(`button-${variant}`);
	size && classNames.push(`button-${size}`);
	if (props.className) classNames.push(props.className);
	if (href) classNames.push("block");

	return href ? (
		<a href={href} {...props} className={classNames.join(" ")}>
			{loading ? loadingText : children}
		</a>
	) : (
		<button
			type="button"
			{...props}
			value={loading ? loadingText : (value ?? (children as string))}
			className={classNames.join(" ")}
		>
			{loading ? loadingText : children}
		</button>
	);
};
